var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e8eaed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M460-125.62v-342.92L160-642v306.38q0 17.39 8.58 32.31 8.57 14.93 23.73 23.62L460-125.62Zm40 0 267.69-154.07q15.16-8.69 23.73-23.62 8.58-14.92 8.58-32.31V-642L500-468.54v342.92Zm146.69-473.84 131.08-75.16-265.46-152.84q-15.16-8.69-32.31-8.69-17.15 0-32.31 8.69L351-771.69l295.69 172.23ZM480-502.92l126.69-73.39-297-171.69-126.92 72.85L480-502.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.eeb3a80afd1a84f54227d9412f901dd7.svg";
export { ForwardRef as ReactComponent };